import { configureStore } from '@reduxjs/toolkit';

import authApi from '@/store/services/authApi';

const buildStore = () =>
    configureStore({
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(authApi.middleware),
        reducer: {
            [authApi.reducerPath]: authApi.reducer,
        },
    });

const store = buildStore();

export { buildStore };
export default store;
